module.exports = __webpack_public_path__ + "img/mt.51f074a.svg";